import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TradeAccountIcon from "@tSurya/Icons/TradeAccountIcon";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    label = "label",
    destination = "destination",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.destination]: LinkFieldValue;
    };
}

export interface TradeAccountStyle {
    tradeAccuntContainer?: LinkPresentationProps;
    tradeAccuntMainContainer?: InjectableCss;
    tradeAccuntIcon?: InjectableCss;
    tradeAccuntLabel?: InjectableCss;
}

export const tradeAccountStyle: TradeAccountStyle = {
    tradeAccuntMainContainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    tradeAccuntContainer: {
        css: css`
            display: flex;
            width: fit-content;
            margin-left: ${isThemeActive(THEME_IDS.MGBW) ? '0' : '20px'};

            > span {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: ${isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW) ? '0' : '2px'};
            }
        `,
    },
    tradeAccuntLabel: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.signInTitle.weight};
            font-size: ${TYPOGRAPHY.header.size};
            line-height: ${TYPOGRAPHY.header.lineHeight};
            text-transform: ${TYPOGRAPHY.openTradeAccountLabel.textTransform};
            color: ${getColor("text.main")};
        `,
    },
};

const styles = tradeAccountStyle;

export const TradeAccount: FC<OwnProps> = ({ fields }) => {
    const { title, url } = useGetLink(fields.destination);
    if (!url) {
        return null;
    }
    return (
        <>
            <Hidden below="md">
                <StyledWrapper {...styles.tradeAccuntMainContainer}>
                    <Link href={url} {...styles.tradeAccuntContainer}>
                        <StyledWrapper {...styles.tradeAccuntLabel}>{fields.label}</StyledWrapper>
                    </Link>
                </StyledWrapper>
            </Hidden>
            <Hidden above="sm">
                <StyledWrapper {...styles.tradeAccuntMainContainer}>
                    <Link href={url} {...styles.tradeAccuntContainer}>
                        <StyledWrapper {...styles.tradeAccuntLabel}>{fields.label}</StyledWrapper>
                    </Link>
                </StyledWrapper>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: TradeAccount,
    definition: {
        group: "Basic",
        displayName: "Trade Account",
        fieldDefinitions: [
            {
                name: fields.label,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.destination,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
